import * as stateManagement from '#packages/stateManagement';

import type { ProgressStatus } from '#packages/constants';

import type { MapStateToProps, MapDispatchToProps } from 'types/redux';

import type {
  PublishButtonDispatchProps,
  PublishButtonOwnProps,
  PublishButtonStateProps,
} from './publish';

import { fixedStage, guidUtils } from '#packages/util';

import experiment from 'experiment';
import * as util from '#packages/util';

const { selectors: savePublishSelectors } = stateManagement.savePublish;
const { getSiteUserPreferences } = stateManagement.userPreferences.selectors;
const { getIsCustomTemplatePublished } =
  stateManagement.customTemplate.selectors;

export const mapStateToProps: MapStateToProps<
  PublishButtonStateProps,
  PublishButtonOwnProps
> = ({ editorAPI, state }) => {
  const disabled =
    !editorAPI.savePublish.canUserPublish() ||
    editorAPI.savePublish.isPublishInProgress() ||
    editorAPI.savePublish.isSaveInProgress() ||
    savePublishSelectors.getIsBuildInProgress(state);

  const shouldSaveBeforePublish =
    editorAPI.publishManager.shouldSaveBeforePublish() ||
    editorAPI.publishManager.hasOverriddenSaveAndPublish();

  const isMobileEditor = editorAPI.isMobileEditor();
  const isInPreviewMode = editorAPI.preview.isInPreviewMode();
  const isSitePublished = editorAPI.dsRead?.generalInfo.isSitePublished();
  const numberOfManualPublish = getSiteUserPreferences('numberOfManualPublish')(
    editorAPI.store.getState(),
  ) as number;
  const devMode = editorAPI.developerMode.isEnabled() ? 'on' : 'off';
  const clickId = guidUtils.getGUID();
  const isCustomTemplate =
    experiment.isOpen('se_customTemplateEditIndication') &&
    util.editorModel.isCustomTemplate;

  const isCustomTemplatePublished = getIsCustomTemplatePublished(state);

  return {
    disabled,
    shouldSaveBeforePublish,
    status: state.publishingStatus as ProgressStatus,
    isMobileEditor,
    isInPreviewMode,
    isSitePublished,
    numberOfManualPublish,
    topBarStateBIParamValue: fixedStage.getTopBarStateBiParamValue(editorAPI),
    devMode,
    clickId,
    isCustomTemplate,
    isCustomTemplatePublished,
  };
};

export const mapDispatchToProps: MapDispatchToProps<
  PublishButtonDispatchProps,
  PublishButtonOwnProps
> = {
  publish: (...args) => stateManagement.savePublish.actions.publish(...args),
  saveAndPublish: (...args) =>
    stateManagement.savePublish.actions.saveAndPublish(...args),
};
